import { render, staticRenderFns } from "./ApplyForAccountCancellationStep2.vue?vue&type=template&id=55ec1e9e&scoped=true&"
import script from "./ApplyForAccountCancellationStep2.vue?vue&type=script&lang=js&"
export * from "./ApplyForAccountCancellationStep2.vue?vue&type=script&lang=js&"
import style0 from "./ApplyForAccountCancellationStep2.vue?vue&type=style&index=0&id=55ec1e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ec1e9e",
  null
  
)

export default component.exports